<template>
    <div v-if="issue_obj">
        <vs-row>
            <vs-col vs-xs="12" vs-sm="8" vs-lg="8">
                <vs-row>
                    <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                        <vs-input
                            :value="issue_obj.data.id ? `Issue #${issue_obj.data.id}` : 'Auto Generated'"
                            label="Issue ID"
                            readonly
                            class="w-full"
                        />
                    </vs-col>
                </vs-row>
                <vs-row>
                    <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                        <label class="vs-input--label block">Resource Allocation</label>
                        <div class="flex mt-3 align-center">
                            <vs-radio v-model="issue_obj.resource_allocation" vs-name="resource_allocation" vs-value="i">Internal</vs-radio>
                            <vs-radio v-model="issue_obj.resource_allocation" vs-name="resource_allocation" vs-value="e" class="mx-3">External</vs-radio>
                        </div>
                        <small class="block text-danger mt-1" v-if="api_errors.resource_allocation">
                            {{ api_errors.resource_allocation.join(', ') }}
                        </small>
                    </vs-col>
                </vs-row>
                <vs-row  v-if="issue_obj.resource_allocation == 'e'">
                    <vs-col vs-xs="12" vs-sm="8" vs-lg="8" class="mb-3">
                        <SelectForeign
                            :model.sync="issue_obj.allocated_resource"
                            label="Select Vendor"
                            placeholder="Type to Search..."
                            :multiple="false"
                            :load_initial="true"
                            :label_keys="['first_name', 'last_name']"
                            :show_id_in_label="false"
                            :endpoint="`${$store.state.apiendpoints.organisation_users}?permission=${allocated_resource_dropdown()}&is_active=true`"
                            container_class="w-full"
                            input_class=""
                            :use_id_as_value="false"
                            :close_on_select="true"
                        />
                        <small class="block text-danger mt-1" v-if="api_errors.allocated_resource">
                            {{ api_errors.allocated_resource.join(', ') }}
                        </small>
                    </vs-col>
                    <vs-col vs-xs="12" vs-sm="8" vs-lg="8" class="mb-3">
                        <SelectForeign
                            :model.sync="issue_obj.allocated_engineer"
                            label="Select Employee"
                            placeholder="Type to Search..."
                            :multiple="false"
                            :load_initial="true"
                            :label_keys="['first_name', 'last_name']"
                            :show_id_in_label="false"
                            :endpoint="`${$store.state.apiendpoints.organisation_users}?permission=${allocated_engineer_external_dropdown()}&is_active=true`"
                            container_class="w-full"
                            input_class=""
                            :use_id_as_value="false"
                            :close_on_select="true"
                        />
                        <small class="block text-danger mt-1" v-if="api_errors.allocated_engineer">
                            {{ api_errors.allocated_engineer.join(', ') }}
                        </small>
                    </vs-col>
                </vs-row>
                <vs-row v-else>
                    <vs-col vs-xs="12" vs-sm="8" vs-lg="8" class="mb-3">
                        <SelectForeign
                            :model.sync="issue_obj.allocated_engineer"
                            label="Select Employee"
                            placeholder="Type to Search..."
                            :multiple="false"
                            :load_initial="true"
                            :label_keys="['first_name', 'last_name']"
                            :show_id_in_label="false"
                            :endpoint="`${$store.state.apiendpoints.organisation_users}?permission=${allocated_engineer_dropdown()}&is_active=true`"
                            container_class="w-full"
                            input_class=""
                            :use_id_as_value="false"
                            :close_on_select="true"
                        />
                        <small class="block text-danger mt-1" v-if="api_errors.allocated_engineer">
                            {{ api_errors.allocated_engineer.join(', ') }}
                        </small>
                    </vs-col>
                </vs-row>
                <vs-row>
                    <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                        <SelectDate
                            :selectedDate.sync="issue_obj.resolution_started_on" 
                            label="Start"
                            class="w-full"
                            :allow_all_dates="true"
                        />
                        <small class="block text-danger mt-1" v-if="api_errors.resolution_started_on">
                            {{ api_errors.resolution_started_on.join(', ') }}
                        </small>
                    </vs-col>
                    <vs-col vs-xs="12" vs-sm="4" vs-lg="4" class="mb-3">
                        <SelectDate
                            :selectedDate.sync="issue_obj.resolution_ended_on" 
                            label="End"
                            class="w-full"
                            :allow_all_dates="true"
                        />
                        <small class="block text-danger mt-1" v-if="api_errors.resolution_ended_on">
                            {{ api_errors.resolution_ended_on.join(', ') }}
                        </small>
                    </vs-col>
                </vs-row>
            </vs-col>
            <vs-col vs-xs="12" vs-sm="4" vs-lg="4">
                <h3 class="text-primary text-center">Summary</h3>
                <vs-divider />
                <vs-row>
                    <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
                        <strong>Date Created: </strong> <FormatText :text="issue_obj.created_on" format="datetime" />
                    </vs-col>
                    <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="mt-3">
                        <strong>Reported Name: </strong> {{ issue_obj.reported_by.first_name }} {{ issue_obj.reported_by.last_name }}
                    </vs-col>
                    <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="mt-3">
                        <strong>Close out assigned: </strong> {{ issue_obj.data.close_out_assigned_to }}
                    </vs-col>
                    <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="mt-3">
                        <strong>Category: </strong> {{ issue_obj.data.category.name}}
                    </vs-col>
                    <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="mt-3">
                        <strong>Issue Type: </strong> {{ issue_obj.data.issue_type.name}}
                    </vs-col>
                    <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="mt-3">
                        <strong>Close out date: </strong> {{ issue_obj.data.close_out_assigned_to }}
                    </vs-col>
                    <vs-col vs-xs="12" vs-sm="12" vs-lg="12" class="mt-3">
                        <strong>Potential: </strong> <FormatText :text="issue_obj.data.potential" format="select" :kwargs="potential_options" />
                    </vs-col>
                </vs-row>   
            </vs-col>
        </vs-row>
    </div>
</template>

<script>

import FileSelection from "../Components/FileSelection.vue"
import LocationChooser from '../Components/LocationChooser.vue'

export default {
    props: {
        issue: {
            required: true,
            type: Object
        },
        api_errors: {
            required: true,
            type: Object
        },
        allocated_resource_dropdown: {
            required: true,
            type: Function
        },
        allocated_engineer_dropdown: {
            required: true,
            type: Function
        },
        allocated_engineer_external_dropdown: {
            required: true,
            type: Function
        },
    },
    components: {
        FileSelection,
        LocationChooser
    },
    data () {
        return {
            issue_obj: null,
            default_data: {
                category: null,
                chainage_from: null,
                chainage_to: null,
                description: null,
                issue_type: null,
                direction: null,
                authority_type: null,
                location_latitude: null,
                location_longitude: null
            },
            potential_options: [
                {label: 'High', value: 'h'},
                {label: 'Medium', value: 'm'},
                {label: 'Low', value: 'l'}
            ],
        }
    },
    watch: {
        issue: {
            deep: true,
            handler: function (newV) {
                this._set_by_watcher = true
                this.update_issue_obj(newV)
            }
        },
        issue_obj: {
            deep: true,
            handler: function (newV) {
                if (this._set_by_watcher) {
                    this._set_by_watcher = false
                    return
                }
                this.$emit('update:issue', newV)
            }
        }
    },
    mounted() {
        this.update_issue_obj(this.issue)
    },
    methods: {
        update_issue_obj(new_data) {
            if (!new_data) this.issue_obj = null
            else {
                let issue_obj = {...new_data}
                if (!issue_obj.data)
                    issue_obj.data = this.deepclone(this.default_data)
                
                this.issue_obj = issue_obj
            }
        }
    }
}
</script>
